import React from 'react';
import cn from 'classnames';
import styles from './HighlightItem.module.scss';
import { HighlightItem } from '@models/HighlightItem';
import renderSharedContactHighlightsMarkdown from '@support/markdown';

interface ContentComponentProps {
  item: HighlightItem;
}

const DefaultContent = ({ item }: ContentComponentProps) => {
  if (item.content) {
    return <>{renderSharedContactHighlightsMarkdown(item)}</>;
  }

  return null;
};

const NewsLink = ({
  item: {
    displaySource,
    metadata: { title, link, image },
  },
}: ContentComponentProps) =>
  !!title &&
  !!link && (
    <a className={styles.newsLink} href={link} target="_blank">
      <div className={styles.copy}>
        <div className={styles.title}>{title}</div>
        <div className={cn(styles.source, 'information-item')}>{displaySource}</div>
      </div>
      {image && <div className={styles.image} style={{ backgroundImage: `url(${image})` }} />}
    </a>
  );

export default function Content({ item }: ContentComponentProps) {
  const ContentDisplay = item.type === 'news' ? NewsLink : DefaultContent;

  return (
    !!item.content && (
      <div className={styles.content}>
        <ContentDisplay item={item} />
      </div>
    )
  );
}
